import React from 'react';
import { ResetButton } from './ResetButton';
import { RequestTag } from './RequestTag';
import { TagsExpandedModeButton } from './TagsExpandedModeButton';

export const TagsExpanded: React.FC<{ content: React.ReactNode }> = ({ content }) => {
  return (
    <div className="al-tags-expanded">
      <div className="al-tags-expanded__main">
        <ResetButton />
        {content}
        <RequestTag />
      </div>
      <div className="al-tags-expanded__mode-btn">
        <TagsExpandedModeButton />
      </div>
    </div>
  );
};
